import { Injectable, Inject } from '@angular/core';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  constructor(
    @Inject(SESSION_STORAGE) private sessionStorage: WebStorageService
  ) {}

  setSession(key, val) {
    this.sessionStorage.set(key, val);
  }

  getSession(key) {
    return this.sessionStorage.get(key);
  }

  removeSession(key) {
    this.sessionStorage.remove(key);
  }
}
